import {React,useState} from 'react'
import { useNavigate } from 'react-router-dom'
import { Paper,IconButton } from '@mui/material'
import {Search} from '@mui/icons-material'



function SearchBar() {
  const [searchItem, setSearchItem] = useState('');
  const navigate=useNavigate();
  const handleSubmit=(e)=>{
    e.preventDefault();
    if(searchItem){
      navigate(`search/${searchItem}`)
      setSearchItem('');
    }
  }
  return (
    <Paper
      component="form"
      onSubmit={handleSubmit}
      sx={{
        border:'1px solid #e3e3e3',
        borderRadius:20,
        pl:2,
        boxShadow:'none',
        mr:{sm:5}
      }}
    >
      <input
        className='search-bar'
        placeholder='Search...'
        value={searchItem}
        style={{
          fontFamily: 'Roboto,Noto,sans-serif',
          fontSize: '16px',
          fontWeight: '400',
          lineHeight: '24px'
        }}
        onChange={(e)=>setSearchItem(e.target.value)}
      />
      <IconButton type='submit' sx={{p:'10px',color:'red'}}>
        <Search/>
      </IconButton>
    </Paper>
  )
}

export default SearchBar